import get from 'lodash.get';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { trackFormInteraction } from '../helpers/checkoutTracking';

let hasAcknowledgmentTracked = false;
let hasRestrictedAlertTracked = false;

const CheckoutNeedsToAcknowledgeRestrictions = ({ transaction, children }) => {
    const restrictionsEnabled = true;
    const { isCheckoutBlocked, hasRestrictedMaterials } = get(transaction, 'warnings') || {};
    const needsToAcknowledgeRestrictions = restrictionsEnabled && hasRestrictedMaterials;

    if (!hasAcknowledgmentTracked && needsToAcknowledgeRestrictions && !isCheckoutBlocked) {
        trackFormInteraction('restrictions on review step displayed');
        hasAcknowledgmentTracked = true;
    }
    if (hasAcknowledgmentTracked && (!needsToAcknowledgeRestrictions || isCheckoutBlocked)) {
        trackFormInteraction('restrictions on review step removed');
        hasAcknowledgmentTracked = false;
    }
    if (!hasRestrictedAlertTracked && needsToAcknowledgeRestrictions && isCheckoutBlocked) {
        trackFormInteraction('restricted materials alert displayed');
        hasRestrictedAlertTracked = true;
    }
    if (hasRestrictedAlertTracked && (!needsToAcknowledgeRestrictions || !isCheckoutBlocked)) {
        trackFormInteraction('restricted materials alert removed');
        hasRestrictedAlertTracked = false;
    }
    return children({ needsToAcknowledgeRestrictions });
};

CheckoutNeedsToAcknowledgeRestrictions.propTypes = {
    transaction: PropTypes.object.isRequired,
    children: PropTypes.func.isRequired,
};

export default createFragmentContainer(CheckoutNeedsToAcknowledgeRestrictions, {
    transaction: graphql`
        fragment CheckoutNeedsToAcknowledgeRestrictions_transaction on Transaction {
            warnings(countryCode: $userCountryCode) {
                isCheckoutBlocked
                hasRestrictedMaterials
            }
        }
    `,
});
